module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [(_vm.mostrarConfirmacionEliminar) ? _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": function($event) {
        return _vm.eliminar()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarTitulo))]), _c('span', {
    attrs: {
      "slot": "information"
    },
    slot: "information"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarDescripcion))]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSendingEliminar) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1)], 1) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalAdjuntar) ? _c('div', {
    staticClass: "overlay-class",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('upload-image', {
    attrs: {
      "name": "curso_virtual",
      "folder": "curso_virtual_portada",
      "onlyImg": true
    },
    on: {
      "save": _vm.guardarAdjunto,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Adjuntar archivo")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Adjunta el archivo  deseado")]), _c('i', {
    staticClass: "fa fa-file",
    attrs: {
      "slot": "topIcon"
    },
    slot: "topIcon"
  })])], 1) : _vm._e()]), _c('div', {
    staticClass: "title pt-5"
  }, [_c('span', {
    staticClass: "fw-400"
  }, [_vm._v(_vm._s(_vm.id ? 'Editar' : 'Nuevo') + " curso virtual")])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "display-flex mb-5"
  }, [_c('div', {
    staticClass: "volver display-flex flex-1"
  }, [_c('button', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.volver()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _c('span', [_vm._v("Volver")])])]), _c('button', {
    staticClass: "button is-small is-primary",
    on: {
      "click": function($event) {
        return _vm.guardarCurso()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _c('span', [_vm._v("Guardar")])])]), _c('div', {
    staticClass: "body pt-10"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Título")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titulo),
      expression: "titulo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoadingCurso
    },
    domProps: {
      "value": (_vm.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titulo = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10 text-center"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Activo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activo),
      expression: "activo"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isLoadingCurso
    },
    domProps: {
      "checked": Array.isArray(_vm.activo) ? _vm._i(_vm.activo, null) > -1 : (_vm.activo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.activo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.activo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.activo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.activo = $$c
        }
      }
    }
  })])]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Descripción")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcion),
      expression: "descripcion"
    }],
    staticClass: "textarea w-300",
    staticStyle: {
      "field-sizing": "content !important"
    },
    attrs: {
      "disabled": _vm.isLoadingCurso
    },
    domProps: {
      "value": (_vm.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcion = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10 text-center"
  }, [(!_vm.imagen) ? _c('button', {
    staticClass: "button is-small is-primary",
    on: {
      "click": _vm.openModalAdjuntar
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-upload is-small"
  })]), _c('span', {
    staticClass: "is-small"
  }, [_vm._v("Adjuntar portada")])]) : _c('button', {
    staticClass: "button is-small is-danger",
    on: {
      "click": function($event) {
        _vm.imagen = ''
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash is-small"
  })]), _c('span', [_vm._v("Borrar Portada")])])]), (_vm.imagen) ? _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imagen,
      "alt": "portada_curso"
    }
  })]) : _vm._e()])]), _c('div', {
    staticClass: "display-flex fdr space-evenly flex-wrap pt-10"
  }, [_c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('materiales-curso-lista', {
    ref: "materialesRef",
    attrs: {
      "type": "curso"
    },
    on: {
      "save": function($event) {
        return _vm.saveMaterial()
      }
    }
  })], 1), _c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('evaluaciones-curso-lista', {
    ref: "evaluacionesRef",
    attrs: {
      "type": "curso"
    },
    on: {
      "save": function($event) {
        return _vm.saveEvaluacion()
      }
    }
  })], 1), _c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('alumnos-curso-lista', {
    ref: "alumnosRef",
    on: {
      "save": function($event) {
        return _vm.saveAlumno()
      }
    }
  })], 1)])]), _c('div', {
    key: "box-clases",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title pt-5"
  }, [_c('span', {
    staticClass: "clase"
  }, [_vm._v("Clases")])]), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.redirigir(0)
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Nuevo")])]), (_vm.lista.length !== 0) ? _c('button', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.fetchClases()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _c('span', [_vm._v("Refrescar")])]) : _vm._e()]), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoadingClase) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Orden")]), _c('th', [_vm._v("Título")]), _c('th', [_vm._v("Descripción")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.activo
      }
    }, [_c('td', [_vm._v(_vm._s(o.orden))]), _c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.titulo))])]), _c('td', [_vm._v(_vm._s(_vm._f("truncateText")(o.descripcion)))]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small mr-5",
      on: {
        "click": function($event) {
          return _vm.redirigir(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])])])])])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "box",
      class: {
        'is-close': !o.activo
      }
    }, [_c('div', {
      staticClass: "descripcion-tipo"
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.titulo))])]), (o.descripcion) ? _c('div', {
      staticClass: "motivo"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm._f("truncateText")(o.descripcion)))])])]) : _vm._e(), (o.orden) ? _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Orden: " + _vm._s(o.orden))])]) : _vm._e(), _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small mr-5",
      on: {
        "click": function($event) {
          return _vm.redirigir(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])])])])
  }), 0)] : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay clases registradas")])])])], 2)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39f38410","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Gestion_Cursos_Editar.vue
// module id = 791
// module chunks = 0